/**
 * 订单路由
 */
 export default [
    {
      path: '/account/account-list',
      component: resolve => require(['../../views/account/account-list'], resolve),
      meta: { title: '账号列表' }
    },
    {
      path: '/account/userSpecialSetting',
      component: resolve => require(['../../views/account/userSpecialSetting'], resolve),
      meta: { title: '特殊授权设置' }
    },
    {
      path: '/account/add-account',
      component: resolve => require(['../../views/account/add-account'], resolve),
      meta: { title: '新增账号' }
    },
    {
      path: '/account/set-account',
      component: resolve => require(['../../views/account/add-account'], resolve),
      meta: { title: '编辑账号' }
    },
    {
      path: '/account/batch-add-area',
      component: resolve => require(['../../views/account/batch-add-area'], resolve),
      meta: { title: '批量权限设置' }
    },
    {
      path: '/account/free-sale-management',
      component: resolve => require(['../../views/account/free-sale-management'], resolve),
      meta: { title: '自由销售人管理' }
    },
  ]
  


// WEBPACK FOOTER //
// ./src/SRM/router/modules/account.js